import { FileExtension } from '@/types/common';
import { AppNavigationConfig, AppNavigationConfigItem } from '@/types/ssr';

import { curry, equals, identity, pipe, prop, toLowerCase } from '../common';
import { anySlashRegExp, specialSymbolRegExp, tabRegExp } from '../regExp';

export const getFileExtension = (path: string) => toLowerCase(path.split('.').pop()) || 'unknown';

export const skipFileExtension = curry<[FileExtension, string], string>((extraExtension, filename) => {
  const dot = '.';
  const isNotAllExt = !equals(extraExtension, 'all');
  const extension = isNotAllExt ? `${dot}${extraExtension}` : dot;
  if (isNotAllExt) return filename.replace(extension, '');
  const lastDotIndex = filename.lastIndexOf(extension);

  if (lastDotIndex <= 0 || equals(lastDotIndex, filename.length - 1)) {
    return filename;
  }

  return filename.slice(0, lastDotIndex);
});

export const compareUrls = (url1: string, url2: string, extraUrlTransform = identity<string>) => {
  const normalize = (url: string) =>
    decodeURIComponent(extraUrlTransform(url))
      .toLowerCase()
      .replace(anySlashRegExp, '')
      .replace(tabRegExp, '-')
      .replace(specialSymbolRegExp, '');

  return equals(normalize(url1), normalize(url2));
};

export const getActiveAppNavigationItem = (
  globalConfig: AppNavigationConfig,
  pathname: string,
  compareWith = 'path' as keyof AppNavigationConfigItem,
) => {
  const isEqualPathAndCompareWithValue = pipe(prop(compareWith), equals(pathname));
  const foundConfigItem = globalConfig.find(isEqualPathAndCompareWithValue);

  if (foundConfigItem) return foundConfigItem;

  return null;
};
